import { UseQueryOptions } from "react-query";
import { IFeedCard } from "src/components/feed-card/types/feed-card";
import { API_FEED_V3_NEWS_RANDOM_TRENDING } from "src/consts/urls";
import { useQuery } from "src/hooks/react-query/use-query";

interface IResults {
    results: IFeedCard[];
}
interface INewsTrendingResponse {
    data: IResults;
    pageNumber: boolean;
    sessionId: string;
    totalResults: number;
}

interface INewsTrendingQueryParams extends UseQueryOptions {
    count: number;
    currentNewsSlug?: string;
}

export const useNewsTrendingQuery = ({ count, currentNewsSlug, enabled }: INewsTrendingQueryParams) => {
    return useQuery<INewsTrendingResponse>(API_FEED_V3_NEWS_RANDOM_TRENDING, {
        queryParams: new URLSearchParams({ count: String(count), currentNewsSlug: String(currentNewsSlug) }),
        enabled,
    });
};
